import React, { useEffect, useState } from 'react';
import {
    MDBBtn,
    MDBCheckbox,
    MDBIcon,
    MDBInput,
    MDBInputGroup,
    MDBModalBody,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBTextArea,
} from 'mdb-react-ui-kit';
import { createCancellationPolicy, logEvent } from '../../services/classApiServices.js';
// import deleteImg from "./../components/images/delete.svg";
import deleteImg from "../../components/images/delete.svg";
import ReactQuill from 'react-quill';
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../../hooks/useAnalytics.js';

function CreateCancellationPolicy(props) {
     const { trackButtonClick } = useAnalytics();
    const [formData, setFormData] = useState({
        name: '',
        cancelfee: [{ days: '', feevalue: '', checked: false }],
        description: '',
    });
    const [validationErrors, setValidationErrors] = useState({
        name: '',
        conditions: '',
    });


    useEffect(() => {

        function fetchData() {
            if (!props.policyinfo) return;

            const obj = {
                name: props.policyinfo.name,
                cancelfee: props.policyinfo.cancelfee,
                description: props.policyinfo.description || '',
                _id: props.policyinfo._id,
                bid: props.policyinfo.bid
            }

            setFormData(obj);

        }

        fetchData();
    }, [props.policyinfo]);

    const handleChange = (field, value, index = null) => {
        if (index !== null) {
            // Update cancel fee
            const updatedFees = [...formData.cancelfee];
            updatedFees[index][field] = value;
            setFormData({ ...formData, cancelfee: updatedFees });
        } else {
            setFormData({ ...formData, [field]: value });
        }
    };

    const handleCheckboxChange = (index) => {
        const updatedFees = [...formData.cancelfee];
        updatedFees[index].checked = !updatedFees[index].checked;
        setFormData({ ...formData, cancelfee: updatedFees });
    };

    const addCondition = () => {
        setFormData({
            ...formData,
            cancelfee: [...formData.cancelfee, { days: '', feevalue: '', checked: false }],
        });
    };

    const handleSubmit = async () => {
        let errors = { name: '', conditions: '' };
        let isValid = true;

        if (!formData.name.trim()) {
            errors.name = 'Name is required';
            isValid = false;
        }

        const hasAtLeastOneCondition = formData.cancelfee.some(fee => fee.checked);
        if (!hasAtLeastOneCondition) {
            errors.conditions = 'Please select at least one condition';
            isValid = false;
        }

        setValidationErrors(errors);
        if (!isValid) return;

        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "Guest";

        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        const gymid = localStorage.getItem("loggedUserInfo")
            ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
            : -1;

        const filteredData = {
            ...formData,
            cancelfee: formData.cancelfee,
            _id: formData._id ? formData._id : -1,
            bid: gymid
        };

        const response = await createCancellationPolicy(gymid, filteredData);

        const action = formData._id ? "updated" : "created";

        const flag = `Cancellation policy ${action} successfully (${formData?.name})`;
        props.onSave(flag);

        
        await trackButtonClick("CancelationPolicy", formData._id ? "Update_Policy" : "Create_Policy", "staff", {});
        await logEvent(
            {
                Eventtype: username1,
                username1,
                fullName,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true
            },
            gymid
        );

    };


    const handleDelete = (indexToDelete) => {
        setFormData(prevData => ({
            ...prevData,
            cancelfee: prevData.cancelfee.filter((_, index) => index !== indexToDelete)
        }));
    };

    return (
        <div>
            <MDBModalHeader>
                <MDBModalTitle>Cancellation Policy</MDBModalTitle>
                <MDBBtn className="btn-close" color="none" onClick={props.onclose}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody style={{ maxHeight: '70vh' }}>
                <div>
                    <label htmlFor="name" className="fw-bold mb-2">
                        Name
                    </label>
                    <MDBInput
                        type="text"
                        placeholder="Enter Full Name"
                        value={formData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                    />
                    {validationErrors.name && (
                        <div className="text-danger mt-1">{validationErrors.name}</div>
                    )}
                </div>

                <div className="mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                        <label htmlFor="conditions" className="fw-bold">
                            Conditions
                        </label>
                        <MDBBtn onClick={addCondition}>
                            <MDBIcon fas icon="plus" />
                        </MDBBtn>
                    </div>

                    {formData.cancelfee.map((fee, index) => (
                        <div className="mb- d-flex align-items-center" key={index}>
                            <MDBCheckbox
                                name={`flexCheck-${index}`}
                                id={`flexCheckDefault-${index}`}
                                checked={fee.checked}
                                onChange={() => handleCheckboxChange(index)}
                            />

                            <div className='my-2 d-flex'>
                                <MDBInputGroup className='group_text mx-2' textAfter={['Days']}  >
                                    <input className='form-control' type='number' placeholder="00"
                                        value={fee.days}
                                        onChange={(e) => handleChange('days', e.target.value, index)} />
                                </MDBInputGroup>


                                <MDBInputGroup className='group_text' textAfter={['% Fee']}  >
                                    <input className='form-control' type='number' placeholder="0% "
                                        value={fee.feevalue}
                                        onChange={(e) => handleChange('feevalue', e.target.value, index)} />
                                </MDBInputGroup>

                            </div>


                            <button
                                className="delete-button"
                                onClick={() => handleDelete(index)}
                                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', marginLeft: '10px' }}
                            >
                                <img src={deleteImg} width="15px" alt="Delete" />
                            </button>


                        </div>
                    ))}
                    {validationErrors.conditions && (
                        <div className="text-danger mt-1">{validationErrors.conditions}</div>
                    )}
                </div>

                <div className="mt-2">
                    <label htmlFor="description" className="fw-bold mb-2">
                        Description
                    </label>
                  
                    <ReactQuill
                        key={formData._id}
                        placeholder="Description"
                        value={formData.description || ''}
                        onChange={(value) => handleChange('description', value)}
                    />
                </div>
            </MDBModalBody>
            <MDBModalFooter className="pe-2 pb-2">
                <MDBBtn color="secondary" onClick={props.onclose}>
                    Cancel
                </MDBBtn>
                <MDBBtn onClick={handleSubmit}>Save</MDBBtn>
            </MDBModalFooter>



        </div>
    );
}

export default CreateCancellationPolicy;
